export const CHART_STYLES = 'chart rounded-lg backdrop-blur-[4.5px] border border-chart-border'

export const EXCHANGE_ORDER: Record<string, number> = {
  BINANCE: 0,
  BITGET: 5,
  BYBIT: 1,
  DERIBIT: 3,
  DYDX: 8,
  GMX: 7,
  HUOBI: 6,
  INTX: 4,
  KWENTA: 8,
  OKX: 2,
  'PERP-PROTOCOL': 10,
  Unallocated: 11,
  VERTEX: 9,
}

export const EXCHANGE_CODE_LOOKUP: Record<string, string> = {
  BGET: 'Bitget',
  BYBT: 'Bybit',
  DRBT: 'Deribit',
  INTX: 'INTX',
  Okx: 'OKX',
}

export const POSITIONS_REQUIRED_EXCHANGES = ['Binance', 'Bybit', 'Deribit', 'OKX', 'Bitget', 'INTX']
